export const isBasicRoute = (pathname: string) => pathname.includes("basic")
export const isSubtasksRoute = (pathname: string) => pathname.includes("subtasks")
export const isKanbanRoute = (pathname: string) => pathname.includes("kanban")
export const isTodoListRoute = (pathname: string) => pathname.includes("todos")
export const isCalendarRoute = (pathname: string) => pathname.includes("calendar")
export const isReportedHoursRoute = (pathname: string) => pathname.includes("reported-hours")

const tabsOrder = ["basic", "subtasks", "todos", "calendar", "kanban", "reported-hours"]

export const getActiveTabIndex = (pathname: string, canViewReportedHoursTab = true) => {
  const index = tabsOrder.findIndex((tab) => pathname.includes(tab))
  if (index === -1) return 0
  if (!canViewReportedHoursTab && tabsOrder[index] === "reported-hours") return 0

  return index
}
